import { createStore } from 'vuex'
import preloader from './modules/preloader';

export default createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    preloader
  }
})
